import script from "./MemberBenefitsView.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberBenefitsView.vue?vue&type=script&setup=true&lang=js"

import "./MemberBenefitsView.vue?vue&type=style&index=0&id=74ca1b44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74ca1b44"]])

export default __exports__